import { Card, Icon, Pressable, Text } from '@ui/themed';
import type { ReactNode } from 'react';
import type { IconName } from './ui/icon/types';

export type ResourcesCardItem = {
  icon: IconName;
  title: string;
  subtitle: string;
  onClick: () => void;
};

export type ResourcesCardProps = {
  title: ReactNode;
  items: ReadonlyArray<ResourcesCardItem>;
};

function ResourceItem({ icon, title, subtitle, onClick }: ResourcesCardItem) {
  return (
    <Pressable type="card" fullHeight onClick={onClick}>
      <Card fullHeight showBorder>
        <Card.Body>
          <div className="flex h-full items-start gap-2">
            <span className="shrink-0 self-center">
              <Icon name={icon} size="md" />
            </span>
            <div className="flex min-w-0 flex-col items-start gap-0.5 text-start [&>p]:w-full">
              <Text truncate>{title}</Text>
              <Text size="sm" variant="secondary">
                {subtitle}
              </Text>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Pressable>
  );
}

export function ResourcesCard({ title, items }: ResourcesCardProps) {
  if (items.length === 0) return null;

  return (
    <Card>
      <Card.Header headingLevel="h2">{title}</Card.Header>
      <Card.Body>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {items.map((item) => (
            <ResourceItem key={item.title} {...item} />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}
